/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Withdraw response
 */
export interface WithdrawResponse {
  /**
   * Transfer ID.
   */
  transferId: number;
}
